webpackJsonp([199769300672215],{

/***/ "./src/components/VideoWorkaround.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/index.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function objectToStyle(obj) {
	  return Object.entries(obj).reduce(function (styleString, entry) {
	    return styleString + entry[0] + ':' + entry[1] + ';';
	  }, '');
	}
	
	var VideoWorkaround = function VideoWorkaround(_ref) {
	  var src = _ref.src,
	      style = _ref.style;
	  return _react2.default.createElement('div', { dangerouslySetInnerHTML: { __html: '\n    <video\n      style=' + objectToStyle(style) + '\n      muted\n      autoplay\n      playsinline\n      src="' + src + '"\n    />\n  ' }
	  });
	};
	
	exports.default = VideoWorkaround;
	module.exports = exports['default'];

/***/ }),

/***/ "./src/pages/gc-inventory-reporting-demo-cropped.mp4":
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/gc-inventory-reporting-demo-cropped.2735c15c.mp4";

/***/ }),

/***/ "./src/pages/opentable-guest-experience.jpg":
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/opentable-guest-experience.1e784457.jpg";

/***/ }),

/***/ "./src/pages/opentable-hero-alt.jpg":
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/opentable-hero-alt.96dcda2b.jpg";

/***/ }),

/***/ "./src/pages/opentable-outdoor-debate.gif":
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/opentable-outdoor-debate.31a988b1.gif";

/***/ }),

/***/ "./src/pages/opentable-pr.jpg":
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/opentable-pr.85685b84.jpg";

/***/ }),

/***/ "./src/pages/opentable-research-bg.jpg":
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/opentable-research-bg.5d85ca94.jpg";

/***/ }),

/***/ "./src/pages/opentable-tc-host.png":
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/opentable-tc-host.228c6391.png";

/***/ }),

/***/ "./src/pages/opentable-tc-setup.png":
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/opentable-tc-setup.a8a4b32c.png";

/***/ }),

/***/ "./node_modules/babel-loader/lib/index.js?{\"plugins\":[\"/Users/adamwagner/Programming/adamwagner.io/node_modules/gatsby/dist/utils/babel-plugin-extract-graphql.js\",\"/Users/adamwagner/Programming/adamwagner.io/node_modules/babel-plugin-add-module-exports/lib/index.js\",\"/Users/adamwagner/Programming/adamwagner.io/node_modules/babel-plugin-transform-object-assign/lib/index.js\"],\"presets\":[[\"/Users/adamwagner/Programming/adamwagner.io/node_modules/babel-preset-env/lib/index.js\",{\"loose\":true,\"uglify\":true,\"modules\":\"commonjs\",\"targets\":{\"browsers\":[\"> 1%\",\"last 2 versions\",\"IE >= 9\"]},\"exclude\":[\"transform-regenerator\",\"transform-es2015-typeof-symbol\"]}],\"/Users/adamwagner/Programming/adamwagner.io/node_modules/babel-preset-stage-0/lib/index.js\",\"/Users/adamwagner/Programming/adamwagner.io/node_modules/babel-preset-react/lib/index.js\"],\"cacheDirectory\":true}!./src/pages/opentable.js":
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/index.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__("./node_modules/gatsby-link/index.js");
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _Box = __webpack_require__("./src/components/Box.js");
	
	var _Box2 = _interopRequireDefault(_Box);
	
	var _List = __webpack_require__("./src/components/List.js");
	
	var _List2 = _interopRequireDefault(_List);
	
	var _Section = __webpack_require__("./src/components/Section.js");
	
	var _Section2 = _interopRequireDefault(_Section);
	
	var _ProjectDetail = __webpack_require__("./src/components/ProjectDetail.js");
	
	var _ProjectDetail2 = _interopRequireDefault(_ProjectDetail);
	
	var _Grid = __webpack_require__("./src/components/Grid.js");
	
	var _Grid2 = _interopRequireDefault(_Grid);
	
	var _GridItem = __webpack_require__("./src/components/GridItem.js");
	
	var _GridItem2 = _interopRequireDefault(_GridItem);
	
	var _VideoWorkaround = __webpack_require__("./src/components/VideoWorkaround.js");
	
	var _VideoWorkaround2 = _interopRequireDefault(_VideoWorkaround);
	
	var _vars = __webpack_require__("./src/styles/vars.json");
	
	var _opentableModule = __webpack_require__("./src/pages/opentable.module.styl");
	
	var _opentableModule2 = _interopRequireDefault(_opentableModule);
	
	var _opentableResearchBg = __webpack_require__("./src/pages/opentable-research-bg.jpg");
	
	var _opentableResearchBg2 = _interopRequireDefault(_opentableResearchBg);
	
	var _opentableOutdoorDebate = __webpack_require__("./src/pages/opentable-outdoor-debate.gif");
	
	var _opentableOutdoorDebate2 = _interopRequireDefault(_opentableOutdoorDebate);
	
	var _opentableGuestExperience = __webpack_require__("./src/pages/opentable-guest-experience.jpg");
	
	var _opentableGuestExperience2 = _interopRequireDefault(_opentableGuestExperience);
	
	var _opentableHeroAlt = __webpack_require__("./src/pages/opentable-hero-alt.jpg");
	
	var _opentableHeroAlt2 = _interopRequireDefault(_opentableHeroAlt);
	
	var _opentableTcSetup = __webpack_require__("./src/pages/opentable-tc-setup.png");
	
	var _opentableTcSetup2 = _interopRequireDefault(_opentableTcSetup);
	
	var _opentableTcHost = __webpack_require__("./src/pages/opentable-tc-host.png");
	
	var _opentableTcHost2 = _interopRequireDefault(_opentableTcHost);
	
	var _gcInventoryReportingDemoCropped = __webpack_require__("./src/pages/gc-inventory-reporting-demo-cropped.mp4");
	
	var _gcInventoryReportingDemoCropped2 = _interopRequireDefault(_gcInventoryReportingDemoCropped);
	
	var _opentablePr = __webpack_require__("./src/pages/opentable-pr.jpg");
	
	var _opentablePr2 = _interopRequireDefault(_opentablePr);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var OpenTable = function (_React$Component) {
	  _inherits(OpenTable, _React$Component);
	
	  function OpenTable() {
	    _classCallCheck(this, OpenTable);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  OpenTable.prototype.render = function render() {
	    return _react2.default.createElement(
	      _ProjectDetail2.default,
	      { projectName: "opentable" },
	      _react2.default.createElement(
	        "div",
	        { ref: "content" },
	        _react2.default.createElement(
	          _Section2.default,
	          { reverse: true },
	          _react2.default.createElement(
	            _Grid2.default,
	            null,
	            _react2.default.createElement(
	              _GridItem2.default,
	              { leftThree: true },
	              _react2.default.createElement(
	                "h1",
	                { style: { WebkitFontSmoothing: 'antialiased' } },
	                "Balancing the marketplace by enabling guests to book the bar."
	              )
	            ),
	            _react2.default.createElement("div", {
	              style: {
	                gridColumn: "1 / span 2",
	                height: "6.666px",
	                background: "rgba(255,255,255,0.5)"
	              }
	            }),
	            _react2.default.createElement("br", null),
	            _react2.default.createElement("br", null),
	            _react2.default.createElement(
	              _GridItem2.default,
	              { leftOne: true, className: "hideMobile overview" },
	              _react2.default.createElement(
	                "p",
	                {
	                  className: "projectSectionMarker",
	                  style: { textAlign: "left" }
	                },
	                "Overview"
	              )
	            ),
	            _react2.default.createElement(
	              _GridItem2.default,
	              { centerTwo: true, style: { marginBottom: "1.5em" } },
	              _react2.default.createElement(
	                "p",
	                null,
	                "As a product manager at OpenTable, I worked on the availability system that connects restaurants and diners. In OpenTable's supply-constrained marketplace, incremental availability has a direct, positive impact for the business, guests, and restaurants."
	              ),
	              _react2.default.createElement(
	                "p",
	                null,
	                "User research validated that the primary path to increasing availability was to enable restaurants to merchandise previously unutilized seats. And to do ",
	                _react2.default.createElement(
	                  "em",
	                  null,
	                  "that"
	                ),
	                ", the product needed to enable restaurants to set guest expectations about their non-traditional dining experiences."
	              ),
	              _react2.default.createElement(
	                "p",
	                null,
	                "The results were fantastic. The initiative has added more incremental availability than existed in some smaller geographic markets and is still growing. Beyond bottom-line benefit, it layed the groundwork for OpenTable to power more memorable, unique dining experiences for guests."
	              )
	            ),
	            _react2.default.createElement(
	              _GridItem2.default,
	              { rightOne: true, className: "hideMobile projectDetails" },
	              _react2.default.createElement(_List2.default, { title: "Company", items: ["OpenTable"] }),
	              _react2.default.createElement(_List2.default, { title: "Role", items: ["Product manager"] })
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _Section2.default,
	          { contain: true, className: _opentableModule2.default.processContainer },
	          _react2.default.createElement(
	            _Grid2.default,
	            null,
	            _react2.default.createElement(
	              "div",
	              { className: _opentableModule2.default.processItem, date: "Q4 2015" },
	              _react2.default.createElement(
	                "p",
	                null,
	                "Discovery & analysis"
	              ),
	              _react2.default.createElement(
	                "p",
	                null,
	                "User research"
	              ),
	              _react2.default.createElement(
	                "p",
	                null,
	                "Analysis"
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: _opentableModule2.default.processItem, date: "Q1 2016" },
	              _react2.default.createElement(
	                "p",
	                null,
	                "Product design"
	              ),
	              _react2.default.createElement(
	                "p",
	                null,
	                "Determine table types"
	              ),
	              _react2.default.createElement(
	                "p",
	                null,
	                "The 'outdoor' debate"
	              ),
	              _react2.default.createElement(
	                "p",
	                null,
	                "Guest experience"
	              ),
	              _react2.default.createElement(
	                "p",
	                null,
	                "Restaurant experience"
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: _opentableModule2.default.processItem, date: "Q2 2016" },
	              _react2.default.createElement(
	                "p",
	                null,
	                "Launch"
	              ),
	              _react2.default.createElement(
	                "p",
	                null,
	                "Strategy"
	              ),
	              _react2.default.createElement(
	                "p",
	                null,
	                "Featured collections"
	              ),
	              _react2.default.createElement(
	                "p",
	                null,
	                "Internal reporting dashboard"
	              ),
	              _react2.default.createElement(
	                "p",
	                null,
	                "Press"
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: _opentableModule2.default.processItem, date: "Q3 2016" },
	              _react2.default.createElement(
	                "p",
	                null,
	                "Results"
	              ),
	              _react2.default.createElement(
	                "p",
	                null,
	                "Qualitative"
	              ),
	              _react2.default.createElement(
	                "p",
	                null,
	                "Quantitative"
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _Section2.default,
	          { color: _vars.colors.white, style: { paddingBottom: 0 } },
	          _react2.default.createElement(
	            _Grid2.default,
	            { style: { marginBottom: "3em" } },
	            _react2.default.createElement(
	              _GridItem2.default,
	              { leftOne: true, className: "hideMobile" },
	              _react2.default.createElement(
	                "p",
	                { className: "projectSectionMarker" },
	                "Discovery"
	              )
	            ),
	            _react2.default.createElement(
	              _GridItem2.default,
	              { centerTwo: true },
	              _react2.default.createElement(
	                "h3",
	                { style: { color: _vars.colors.red } },
	                "User research"
	              ),
	              _react2.default.createElement(
	                "p",
	                null,
	                "In the fall of 2015, myself and several colleagues met with six restaurateurs in Los Angeles in search of ways to increase reservation availability on OpenTable's marketplace."
	              ),
	              _react2.default.createElement(
	                "p",
	                null,
	                "Questions focused on the reasons restaurateurs held back tables from OpenTable. If OpenTable could address those use cases, we could ostensibly increase table availability significantly."
	              ),
	              _react2.default.createElement(
	                "p",
	                null,
	                "We began the research open-minded. But after three interviews, all of us began zeroing in on an emerging opportunity: ",
	                _react2.default.createElement(
	                  "strong",
	                  null,
	                  "a way to set guest expectations around non-traditional seats such as the bar or counter"
	                ),
	                "."
	              )
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: _opentableModule2.default.researchQuote, img: _opentableResearchBg2.default },
	            _react2.default.createElement(
	              "p",
	              null,
	              "\u201CWe need to manage people\u2019s expectations about inside / outside / counter seating."
	            ),
	            _react2.default.createElement(
	              "p",
	              null,
	              "The counter seating MUST be booked on the phone. Unless OpenTable had a way to tell the guest \u2026\u201D"
	            )
	          ),
	          _react2.default.createElement(
	            _Grid2.default,
	            { style: { marginBottom: "6em" } },
	            _react2.default.createElement(
	              _GridItem2.default,
	              { centerTwo: true },
	              _react2.default.createElement(
	                "p",
	                null,
	                "As of yet, OpenTable hadn't differentiated seating types. A guest simply makes a 'reservation'. And to most guests \u2014 especially those that have been with OpenTable since its fine-dining roots \u2014 a reservation meant table service in the main dining room."
	              ),
	              _react2.default.createElement(
	                "p",
	                null,
	                "It's easy to understand how guests could be upset:"
	              ),
	              _react2.default.createElement(
	                "ul",
	                { style: { marginBottom: '1.5em' }, className: "multi-line" },
	                _react2.default.createElement(
	                  "li",
	                  null,
	                  _react2.default.createElement(
	                    "strong",
	                    null,
	                    "Bar seating: "
	                  ),
	                  "Backless stools can be uncomfortable, the bar surface can be sticky, and parties larger than 3 will find conversation difficult."
	                ),
	                _react2.default.createElement(
	                  "li",
	                  null,
	                  _react2.default.createElement(
	                    "strong",
	                    null,
	                    "Patio seating: "
	                  ),
	                  "Sun, wind and rain can cause discomfort. At some restaurants, the patio may be a less energetic experience than the main dining room."
	                ),
	                _react2.default.createElement(
	                  "li",
	                  null,
	                  _react2.default.createElement(
	                    "strong",
	                    null,
	                    "High-Top seating: "
	                  ),
	                  "A High-Top is a raised table with raised seats that are sometimes backless. For parties with elderly guests or guests that use a wheelchair, High-Tops can be inconvinient at best and a show-stopper at worst."
	                )
	              ),
	              _react2.default.createElement(
	                "p",
	                null,
	                "Bottom line \u2014 guests need to know what kind of experience they're booking. For hot restaurants with limited availability, guests would be willing to compromise just to get in. And some guests simply ",
	                _react2.default.createElement(
	                  "em",
	                  null,
	                  "prefer"
	                ),
	                " the bustling experience of dining at the bar."
	              ),
	              _react2.default.createElement(
	                "p",
	                null,
	                "If OpenTable could give guests the choice, restaurateurs could open up an additional 30 - 60 percent of their tables for reservations."
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _Grid2.default,
	            null,
	            _react2.default.createElement(
	              _GridItem2.default,
	              { leftOne: true, className: "hideMobile" },
	              _react2.default.createElement(
	                "p",
	                { className: "projectSectionMarker" },
	                "Product design"
	              )
	            ),
	            _react2.default.createElement(
	              _GridItem2.default,
	              { centerTwo: true },
	              _react2.default.createElement(
	                "h3",
	                { style: { color: _vars.colors.red } },
	                "Analysis"
	              ),
	              _react2.default.createElement(
	                "p",
	                { style: { marginTop: '1.5em' } },
	                _react2.default.createElement(
	                  "strong",
	                  null,
	                  "Qualitative"
	                )
	              ),
	              _react2.default.createElement(
	                "ul",
	                { className: "arrow-list", style: { marginBottom: "1.5em" } },
	                _react2.default.createElement(
	                  "li",
	                  null,
	                  " Identify themes in user research "
	                ),
	                _react2.default.createElement(
	                  "li",
	                  null,
	                  " Cross-reference with related guest research "
	                )
	              ),
	              _react2.default.createElement(
	                "p",
	                { style: { marginTop: '1.5em' } },
	                _react2.default.createElement(
	                  "strong",
	                  null,
	                  "Quantitative"
	                )
	              ),
	              _react2.default.createElement(
	                "ul",
	                { className: "arrow-list", style: { marginBottom: '1.5em' } },
	                _react2.default.createElement(
	                  "li",
	                  null,
	                  " Measure seating requests in guest notes "
	                ),
	                _react2.default.createElement(
	                  "li",
	                  null,
	                  " Infer # of non-traditional seats via floor plan data"
	                )
	              ),
	              _react2.default.createElement(
	                "p",
	                null,
	                "Analysis yielded a clear, prioritized list of table types to support based on user behavior and table composition from the floor plans of live restaurants."
	              ),
	              _react2.default.createElement(
	                "ol",
	                null,
	                _react2.default.createElement(
	                  "li",
	                  null,
	                  "Patio seating"
	                ),
	                _react2.default.createElement(
	                  "li",
	                  null,
	                  "Bar seating"
	                ),
	                _react2.default.createElement(
	                  "li",
	                  null,
	                  "High-Top seating"
	                ),
	                _react2.default.createElement(
	                  "li",
	                  null,
	                  "Counter seating"
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _Section2.default,
	          { color: _vars.colors.white },
	          _react2.default.createElement(
	            _Grid2.default,
	            null,
	            _react2.default.createElement(
	              _GridItem2.default,
	              { leftOne: true, className: "hideMobile" },
	              _react2.default.createElement(
	                "p",
	                { className: "projectSectionMarker" },
	                "Product design"
	              )
	            ),
	            _react2.default.createElement(
	              _GridItem2.default,
	              { centerTwo: true },
	              _react2.default.createElement(
	                "h3",
	                { style: { color: _vars.colors.red } },
	                "The debate over outdoor seating"
	              ),
	              _react2.default.createElement(
	                "p",
	                null,
	                "No issue was more hotly debated than whether patio seating should be included in version 1 as a ",
	                _react2.default.createElement(
	                  "em",
	                  null,
	                  "table type."
	                )
	              ),
	              _react2.default.createElement("img", { src: _opentableOutdoorDebate2.default, alt: "", style: { marginBottom: '1.5em' } }),
	              _react2.default.createElement(
	                "p",
	                null,
	                "The conceptual friction not only compromised the data model \u2014 it made it impossible to model ",
	                _react2.default.createElement(
	                  "strong",
	                  null,
	                  "bar seats located on the patio"
	                ),
	                "."
	              ),
	              _react2.default.createElement(
	                "p",
	                { style: { marginBottom: '1.5em' } },
	                "Technical constraints prohibited the obvious approach of modeling availability area attributes (indoor / outdoor) in addition to availability seating types (bar, high-top, counter, etc). This approach would more than double implementation time and require a significant redesign of search services powering OpenTable's diner apps. It would also explode the complexity of how OpenTable buckets availability types."
	              ),
	              _react2.default.createElement(
	                "h4",
	                { style: { color: _vars.colors.red } },
	                "Deferring dedicated area modeling"
	              ),
	              _react2.default.createElement(
	                "p",
	                null,
	                "The effort to clean up the data model in a future iteration was not significantly more than implementing it upfront. So, I descoped it \u2014 opting to halve implementation time and take on the very real risk that phase 2 would never happen."
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _Section2.default,
	          { color: _vars.colors.white, flush: true },
	          _react2.default.createElement(
	            _Grid2.default,
	            null,
	            _react2.default.createElement(
	              "div",
	              { className: "hideMobile" },
	              _react2.default.createElement(
	                "p",
	                { className: "projectSectionMarker" },
	                "Product design"
	              )
	            ),
	            _react2.default.createElement(
	              _GridItem2.default,
	              { centerTwo: true, style: { marginBottom: '1.5em' } },
	              _react2.default.createElement(
	                "h3",
	                { style: { color: _vars.colors.red } },
	                "The guest experience"
	              ),
	              _react2.default.createElement(
	                "p",
	                null,
	                "Although I was technically only responsible for the restaurant experience, I worked closely with guest product and design teams to push the initiative forward."
	              ),
	              _react2.default.createElement(
	                "p",
	                null,
	                "Speed was favored over perfection. Personally, I wasn't thrilled with the design of the guest experience, but it was enough to launch and validate the concept."
	              )
	            )
	          ),
	          _react2.default.createElement("img", { src: _opentableHeroAlt2.default, alt: "" }),
	          _react2.default.createElement("img", { src: _opentableGuestExperience2.default, alt: "" })
	        ),
	        _react2.default.createElement(
	          _Section2.default,
	          { reverse: true, color: _vars.colors.asphalt },
	          _react2.default.createElement(
	            _Grid2.default,
	            null,
	            _react2.default.createElement(
	              "div",
	              { className: "hideMobile" },
	              _react2.default.createElement(
	                "p",
	                { className: "projectSectionMarker" },
	                "Product design"
	              )
	            ),
	            _react2.default.createElement(
	              _GridItem2.default,
	              { centerTwo: true },
	              _react2.default.createElement(
	                "h3",
	                null,
	                "The restaurant experience"
	              ),
	              _react2.default.createElement(
	                "p",
	                null,
	                "The restaurant user experience was straightforward: select a table or lasso a group of tables, and adjust the table type in the sidebar."
	              ),
	              _react2.default.createElement(
	                "p",
	                null,
	                "Capturing a table's type had benefits beyond this initiative \u2014 it added structure for grouping tables together for future features."
	              )
	            )
	          ),
	          _react2.default.createElement("img", { src: _opentableTcSetup2.default, style: { maxWidth: '1600px', margin: 'auto' }, alt: "" }),
	          _react2.default.createElement("img", { src: _opentableTcHost2.default, style: { maxWidth: '1600px', margin: 'auto' }, alt: "" })
	        ),
	        _react2.default.createElement(
	          _Section2.default,
	          { color: _vars.colors.white },
	          _react2.default.createElement(
	            _Grid2.default,
	            null,
	            _react2.default.createElement(
	              "div",
	              { className: "hideMobile" },
	              _react2.default.createElement(
	                "p",
	                { className: "projectSectionMarker" },
	                "Launch"
	              )
	            ),
	            _react2.default.createElement(
	              _GridItem2.default,
	              { centerTwo: true },
	              _react2.default.createElement(
	                "h3",
	                { style: { color: _vars.colors.red } },
	                "Launch strategy"
	              ),
	              _react2.default.createElement(
	                "p",
	                null,
	                "In a sales-driven two-sided marketplace such as OpenTable, a solid launch strategy is key to scaling adoption and engagement of a new feature."
	              ),
	              _react2.default.createElement(
	                "p",
	                null,
	                "The supply side needed to come first. Restaurants needed to be on board with accepting reservations on their bar, high-top, patio, and counter seats in order for guests to have the opportunity to engage."
	              ),
	              _react2.default.createElement(
	                "p",
	                null,
	                _react2.default.createElement(
	                  "strong",
	                  null,
	                  "Approach to supply side launch"
	                )
	              ),
	              _react2.default.createElement(
	                "ul",
	                { className: "arrow-list", style: { marginBottom: "1.5em" } },
	                _react2.default.createElement(
	                  "li",
	                  null,
	                  "Engage the sales team in a test market ",
	                  _react2.default.createElement(
	                    "em",
	                    null,
	                    "early"
	                  ),
	                  " in the development process to gather feedback and engender support."
	                ),
	                _react2.default.createElement(
	                  "li",
	                  null,
	                  "Ensure all supporting collateral is ready for launch in test market"
	                ),
	                _react2.default.createElement(
	                  "li",
	                  null,
	                  "Work with sales leadership to determine sales strategy. In this case, position the feature not as an optional enhancement, but a fundamental update to how OpenTable functions. Include setup as part of regular meetings with restaurants."
	                ),
	                _react2.default.createElement(
	                  "li",
	                  null,
	                  "Work with sales leadership to define incentive plan linked to adoption."
	                ),
	                _react2.default.createElement(
	                  "li",
	                  null,
	                  "Be on-site for initial setup meetings with restaurants in test market."
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _Section2.default,
	          { color: _vars.colors.white },
	          _react2.default.createElement(
	            _Grid2.default,
	            null,
	            _react2.default.createElement(
	              "div",
	              { className: "hideMobile" },
	              _react2.default.createElement(
	                "p",
	                { className: "projectSectionMarker" },
	                "Launch"
	              )
	            ),
	            _react2.default.createElement(
	              _GridItem2.default,
	              { centerTwo: true, style: { marginBottom: '1.5em' } },
	              _react2.default.createElement(
	                "h3",
	                { style: { color: _vars.colors.red } },
	                "Tracking progress"
	              ),
	              _react2.default.createElement(
	                "p",
	                null,
	                "Tracking progress is an important part of any launch. At the time, data on supply-side and demand-side adoption and engagement lived in disparate systems. On nights and weekends, ",
	                _react2.default.createElement(
	                  "strong",
	                  null,
	                  "I designed & built a custom KPI tracking dashboard"
	                ),
	                " ",
	                " ",
	                "that enabled the product team to track progress and powered the sales incentive program with a built-in leaderboard."
	              ),
	              _react2.default.createElement(
	                "p",
	                null,
	                "The dashboard integrated with MongoDB, Salesforce, Mixpanel, and OpenTable's data warehouse to provide a 360\xB0 overview of the launch."
	              ),
	              _react2.default.createElement(
	                "p",
	                null,
	                _react2.default.createElement(
	                  "em",
	                  null,
	                  "Note: actual numbers, names, and locations have been obfuscated or altered."
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(_VideoWorkaround2.default, {
	            autoPlay: true,
	            loop: true,
	            src: _gcInventoryReportingDemoCropped2.default,
	            type: "video/mp4",
	            style: {
	              position: "static",
	              opacity: 1,
	              display: "block",
	              width: "100%",
	              objectFit: "fill"
	            }
	          })
	        ),
	        _react2.default.createElement(
	          _Section2.default,
	          { color: _vars.colors.white },
	          _react2.default.createElement(
	            _Grid2.default,
	            null,
	            _react2.default.createElement(
	              "div",
	              { className: "hideMobile" },
	              _react2.default.createElement(
	                "p",
	                { className: "projectSectionMarker" },
	                "Launch"
	              )
	            ),
	            _react2.default.createElement(
	              _GridItem2.default,
	              { centerTwo: true, style: { marginBottom: '1.5em' } },
	              _react2.default.createElement(
	                "h3",
	                { style: { color: _vars.colors.red } },
	                "Public relations, training, and support"
	              ),
	              _react2.default.createElement(
	                "p",
	                null,
	                "The public relations team did a fantastic job getting press in Eater and major metro news channels. "
	              ),
	              _react2.default.createElement("img", { src: _opentablePr2.default, alt: "", style: { marginBottom: '1.5em' } }),
	              _react2.default.createElement(
	                "p",
	                null,
	                "The training team created walk-through video tutorials and wrote documentation for OpenTable's community support site. Support leads helped train the support team to field questions from restaurants and guests about the new feature."
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _Section2.default,
	          { color: _vars.colors.white },
	          _react2.default.createElement(
	            _Grid2.default,
	            null,
	            _react2.default.createElement(
	              "div",
	              { className: "hideMobile" },
	              _react2.default.createElement(
	                "p",
	                { className: "projectSectionMarker" },
	                "Results"
	              )
	            ),
	            _react2.default.createElement(
	              _GridItem2.default,
	              { centerTwo: true, style: { marginBottom: '1.5em' } },
	              _react2.default.createElement(
	                "h3",
	                { style: { color: _vars.colors.red } },
	                "Happy restaurants, happy guets, and incremental revenue"
	              ),
	              _react2.default.createElement(
	                "p",
	                null,
	                "Restaurants that accepted parties at their bar, counter, high-top and outdoor seats saw an ",
	                _react2.default.createElement(
	                  "strong",
	                  null,
	                  "increase in the average order amount"
	                ),
	                " \u2014 especially at seats that are traditionally glorified waiting areas. "
	              ),
	              _react2.default.createElement(
	                "p",
	                { style: { marginBottom: '3em' } },
	                "This feature also made restaurants effectively bigger. Restaurants were able to better utilize their large tables by seating more two-tops at the bar. Eric Kirkenmeier of the James Beard Award-winning restaurant ",
	                _react2.default.createElement(
	                  "em",
	                  null,
	                  "Cherry Circle Room"
	                ),
	                " said \u201C\u2026it\u2019s allowed us to ",
	                _react2.default.createElement(
	                  "strong",
	                  null,
	                  "fit more people in the room, period."
	                ),
	                "\u201D"
	              ),
	              _react2.default.createElement("iframe", { width: "560", height: "315", src: "https://www.youtube.com/embed/-aLQ8qR8MI4", frameBorder: "0", allowFullScreen: true }),
	              _react2.default.createElement(
	                "blockquote",
	                { style: { padding: 0, margin: '1.5em 0' } },
	                "\u201CWe noticed a change in our revenue immediately; we noticed a change also in the spirits of the bartenders. It\u2019s nice that we know for sure certain seats will always be full every single night.\u201D",
	                _react2.default.createElement(
	                  "p",
	                  null,
	                  _react2.default.createElement(
	                    "em",
	                    null,
	                    "\u2014Lien Ta, Here's Looking at You"
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                "p",
	                null,
	                "Because of the increased availability, guests were now more likely to find a spot at hot restaurants. As a bonus, many guests were excited by the option to ",
	                _react2.default.createElement(
	                  "em",
	                  null,
	                  "choose the bar"
	                ),
	                ", which often offers a higher-energy dining experience."
	              ),
	              _react2.default.createElement(
	                "p",
	                null,
	                "The feature added more incremental availability than some of OpenTable's smaller geographic regions. As expected, incremental bookings quickly followed the increase in availability, adding directly to OpenTable's bottom line."
	              )
	            )
	          )
	        )
	      )
	    );
	  };
	
	  return OpenTable;
	}(_react2.default.Component);
	
	exports.default = OpenTable;
	module.exports = exports["default"];

/***/ }),

/***/ "./src/pages/opentable.module.styl":
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"hide--mobile":"src-pages----opentable-module---hide--mobile---3YP12","show--mobile":"src-pages----opentable-module---show--mobile---3HCpx","hide--tablet":"src-pages----opentable-module---hide--tablet---2_Nq3","show--tablet":"src-pages----opentable-module---show--tablet---2-2dE","hide--desk":"src-pages----opentable-module---hide--desk---3GQ8p","show--desk":"src-pages----opentable-module---show--desk---3R3g_","hide--huge":"src-pages----opentable-module---hide--huge---3147d","show--huge":"src-pages----opentable-module---show--huge---2F5Sh","textSecondary":"src-pages----opentable-module---textSecondary---2vtI4","textSecondaryBold":"src-pages----opentable-module---textSecondaryBold---2-fxm","processContainer":"src-pages----opentable-module---processContainer---1p_1n","textBold":"src-pages----opentable-module---textBold---9EDNM","processItem":"src-pages----opentable-module---processItem---2O-X7","researchQuote":"src-pages----opentable-module---researchQuote---3TMtL"};

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-opentable-js-7048d13058b78edeedcf.js